// PendingDecisions.jsx — 확인 필요 계약·취소에 큰 [넣기][빼기] 버튼 (2026-10-06 UX)
//   계약: 넣기(included) / 빼기(excluded) · 취소: 차감함(included) / 차감 안 함(excluded) — 서버 값은 종전 select 와 같다.
import React from 'react';
import { amountText, eventTypeLabel, itemSummary, shortDate } from './eventListModel';
import { C } from './charge.styles';

const P = {
  item: { border: '1px solid rgba(245,158,11,0.35)', borderRadius: 12, padding: 10, background: 'var(--bg-card)', display: 'flex', flexDirection: 'column', gap: 6 },
  top: { display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'baseline' },
  title: { fontSize: 14, fontWeight: 800, color: 'var(--text)', minWidth: 0, overflowWrap: 'anywhere' },
  amount: (cancel) => ({ fontSize: 13, fontWeight: 900, color: cancel ? '#dc2626' : '#2563eb', whiteSpace: 'nowrap' }),
  meta: { fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.5, overflowWrap: 'anywhere' },
  btns: { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 8 },
  btn: (tone) => ({
    minHeight: 44, borderRadius: 10, fontSize: 14, fontWeight: 800, cursor: 'pointer',
    border: `1px solid ${tone === 'in' ? 'rgba(37,99,235,0.35)' : 'var(--border)'}`,
    background: tone === 'in' ? 'rgba(37,99,235,0.08)' : 'var(--bg-card)', color: tone === 'in' ? '#2563eb' : 'var(--text-sub)',
  }),
};

export function PendingDecisions({ row, disabled, onDecide }) {
  const events = (row?.events || []).filter((event) => event.chargeDecisionStatus === 'pending');
  if (!events.length) return null;
  return (
    <div style={{ ...C.section, borderColor: 'rgba(245,158,11,0.45)', background: 'rgba(245,158,11,0.06)' }}>
      <div style={C.sectionTitle}>확인 필요 {events.length}건</div>
      <div style={C.sectionHint}>
        1:1 기간 밖에서 미팅했거나 계약취소 처리가 끝나지 않은 건처럼 자동으로 정할 수 없는 계약이에요. 이 직원 1:1급여(인정 장수)에 넣을지 정해 주세요.
      </div>
      {events.map((event, index) => {
        const cancel = event.type === 'cancel';
        const items = itemSummary(event.items || []);
        return (
          <div key={`${event.contractId}-${event.type}-${index}`} style={P.item}>
            <div style={P.top}>
              <span style={P.title}>{shortDate(event.date)} {eventTypeLabel(event)} · {event.companyName || '-'}</span>
              <span style={P.amount(cancel)}>{amountText(event)}</span>
            </div>
            <div style={P.meta}>
              마케터 {event.salesPersonName || '-'}
              {event.meetingDate ? ` · 미팅 ${shortDate(event.meetingDate)}` : ''}
              {event.isReorder ? ' · 재계약' : ''}
              {items ? ` · ${items}` : ''}
            </div>
            <div style={P.btns}>
              <button type="button" style={P.btn('in')} disabled={disabled} onClick={() => onDecide(event, 'included')}>
                {cancel ? '차감함' : '넣기'}
              </button>
              <button type="button" style={P.btn('out')} disabled={disabled} onClick={() => onDecide(event, 'excluded')}>
                {cancel ? '차감 안 함' : '빼기'}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
